import React from "react";
import { NumbersNew } from "../global/NumbersNew";

export const StatsNew = ({ stats, color = "green" }) => {
  return (
    <>
      {stats.length > 0 && (
        <div className="pt-lg-16 pb-lg-16 pb-0 pt-11 mb-0  d-flex justify-center align-center position-relative">
            <div className="container">
            <NumbersNew stats={stats} color={color} isFront={true} />
            </div>
        </div>
      )}
    </>
  );
};

